var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"happ"}},[_c('router-view'),_c('video',{attrs:{"id":"demosysVedio","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("./assets/images/ddvedio.mp4"),"type":"video/mp4"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }